import React, { useMemo } from "react";
import { useTranslation } from "@opendash/core";
import { ParseSetView } from "@opendash/plugin-parse";
import { TableViewType } from "@opendash/plugin-parse/dist/types";
import { ColumnProps } from "antd/lib/table";

const AJKClass = "HG_AJK";

export default function AJKMeta() {
  const t = useTranslation();

  return (
    <ParseSetView
      className={AJKClass}
      view={
        {
          type: "table",

          fields: ["machine", "ajk_number", "hg_number"],
        } as TableViewType
      }
    />
  );
}
